import { createContext } from 'react';

export const AppRouteConfigContext = createContext<{
  theme?: string;
  headerStyle?: string;
  hideHeaderLogo?: boolean;
}>({});
